//TODO: Remove exponea implementation of upselling recommendation, when it is clear there will be no further usage

import * as React from 'react';

import { useQuery } from '@apollo/client';

import {
  UpsellingProductsQuery,
  UpsellingProductsQueryVariables,
} from '@notino/shared/definitions/types';

import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetail/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';
import { useTrackingContext } from '@context/tracking/TrackingContext';

import databreakersUpsellingQuery from './queries/databreakersUpsellingQuery.graphql';
import { RelatedWrapper } from './styled';
import { UpsellingList } from './UpsellingList';
import { notifyCypressUpsellingDisabled, trackUpsellingOpen } from './utils';

interface IUpsellingProductsProps {
  productCodes: string[];
}

export const UpsellingProducts: React.FC<IUpsellingProductsProps> = ({
  productCodes,
}) => {
  const { getTimeFromInit } = useTrackingContext();
  const { recoProductDetailAddToCart } = useFeatureFlags();
  const {
    product: { brand },
  } = useProductDetailContext();

  // Databreakers recommendations
  const { data: databreakersResponse } = useQuery<
    UpsellingProductsQuery,
    UpsellingProductsQueryVariables
  >(databreakersUpsellingQuery, {
    skip: !recoProductDetailAddToCart,
    variables: { productCodes, brandId: brand?.id ? Number(brand.id) : null },
  });

  React.useEffect(() => {
    trackUpsellingOpen({ timing: getTimeFromInit() });
  }, [getTimeFromInit]);

  const isDatabreakersResponseEmpty =
    Boolean(
      databreakersResponse?.getUpsellingProductRecommendationsForMultiple
        ?.recommendedProducts?.length
    ) === false;

  if (isDatabreakersResponseEmpty) {
    notifyCypressUpsellingDisabled(recoProductDetailAddToCart);
    return null;
  }

  return (
    <RelatedWrapper data-testid="upselling-wrapper">
      <UpsellingList
        databreakersProductIds={databreakersResponse.getUpsellingProductRecommendationsForMultiple.recommendedProducts.map(
          (p) => p.productId
        )}
        attributionToken={
          databreakersResponse.getUpsellingProductRecommendationsForMultiple
            .recommendationAttributes?.attributionToken
        }
      />
    </RelatedWrapper>
  );
};
